import React from "react";
import { TouchableOpacity } from "react-native";
import { colors, global } from "../../const";
import { SubtitleLight, SubtitleLightIndigo } from "../labels";


export default function Button({ title, variant, size, disabled, borderRadius, ...others }) {
    let style = {
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: borderRadius || 8,
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.2, shadowRadius: 6,
        shadowColor: 'black',
        backgroundColor: disabled ? colors.disable : colors.indigo,
        height: 50
    }
    if (variant === "outline")
        style = { ...style, borderColor: colors.indigo, borderWidth: 1.2, backgroundColor: "transparent" }

    if (size === "small") style = { ...style, height: 40 }
    else if (size) style = { ...style, height: size }

    if (disabled) delete others.onPress;

    return (
        <TouchableOpacity
            activeOpacity={0.9}
            style={style}
            {...others}
        >
            {
                variant === "outline" ?
                    (
                        <SubtitleLightIndigo bold>
                            {title}
                        </SubtitleLightIndigo>
                    )
                    :
                    (
                        <SubtitleLight bold>
                            {title}
                        </SubtitleLight>
                    )
            }
        </TouchableOpacity>
    )
}

export const IconButton = ({ children, ...others }) => (
    <TouchableOpacity
        style={{ padding: 15, borderRadius: 15 }}
        activeOpacity={0.8}
        {...others}
    >
        {children}
    </TouchableOpacity>
)